import React from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Picture from 'js/components/picture';
import Badge from 'js/components/shared/Badge';

import { GALLERY_POPUP } from "../../../../PopupConstructor/constants";
import openPopup from "../../../../PopupConstructor/actions/popupActions";

import styles from './HotelListCardThumb.module.scss';

const cx = classnames.bind(styles);

const HotelListCardThumb = function (props) {
  const {
    imagesCount = 0,
    openPopupAction,
    firstImage = {},
    images = [],
    hotelId,
    sticker,
    fetchPriority = false,
    className
  } = props;

  const openGalleryPopup = () => {
    openPopupAction(GALLERY_POPUP, hotelId);
  }

  const pictureSources = {
    src: firstImage.src,
    alt: firstImage.alt,
    sources: [
      {
        srcSet: firstImage?.mobile?.src,
        media: `(max-width: 768px)`,
      }
    ]
  };

  const photoText = images.length === 1 ? "photo" : "photos"

  return (
    <div className={cx('thumb-root', className)} onClick={openGalleryPopup}>
      {!!sticker?.title && (
        <Badge
          className={cx('sticker')}
          style={{backgroundColor: sticker.backgroundColor}}
        >
          {sticker.title}
        </Badge>
      )}

      <Picture
        src={pictureSources.src}
        alt={pictureSources.alt}
        fetchPriority={fetchPriority}
        lazy={!fetchPriority}
        sources={pictureSources.sources}
      />
      {imagesCount > 0 && (
        <button className={cx('fancy-box-open-btn')}>
          <i className={cx('icon-photo-image')} />
          {imagesCount}
          <span> {photoText}</span>
        </button>
      )}
    </div>
  )
}

HotelListCardThumb.propTypes = {
  imagesCount: PropTypes.number,
  openPopupAction: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(Object),
  hotelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sticker: PropTypes.oneOfType([PropTypes.object, PropTypes.array]), // BE provides array if there no sticker data.
  firstImage:  PropTypes.object,
  fetchPriority: PropTypes.bool,
  className: PropTypes.string,
}

export default connect(null, { openPopupAction: openPopup })(HotelListCardThumb);
